import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Dropdown from 'react-bootstrap/Dropdown';
// import {
//     FaUserAlt,
// } from 'react-icons/fa';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Nav from 'react-bootstrap/Nav';
import Spinner from 'react-bootstrap/Spinner';
import { Link } from 'react-router-dom';
import { confirm as confirmDialog } from 'react-bootstrap-confirmation';

// const basePath = process.env.ORY_SDK_URL || 'http://localhost:4000';
const store = require('@appblocks/frontend/redux/store').default;

const LoginButton = (props) => {
    const loaded = useSelector(state => state.user.loaded);
    const user = useSelector(state => state.user.user);
    const logoutURL = useSelector(state => state.user.logoutURL);
    // const { loginWithRedirect, logout } = useAuth0();

    if (!loaded) {
        return (
            <Spinner animation="border" role="status" variant="primary" />
        );
    }


    return (
        user ? (
            <Dropdown as={ButtonGroup} align="end" className="ms-1 me-2 justify-content-end profile-icon">
                <Dropdown.Toggle variant="secondary" className="rounded-circle">
                    {/* <FaUserAlt /> */}
                    <span>
                        {user.email[0].toUpperCase()}
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item as={Link} to="/settings/profile">
                        {user.email}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={async () => {
                        const answer = await confirmDialog('Are you sure you want to sign out?');
                        if (answer) {
                            store.dispatch({
                                type: 'user/logout',
                            });
                        }
                    }}
                    >
                        Sign Out
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        ) : (
            <Nav.Link
                className="nav-link float-end me-2"
                style={{
                    margin: 0,
                }}
                href="/auth"
            >
                Sign In
            </Nav.Link>
        )
    );
};

export default LoginButton;
